import React from "react";

import UserPageTemplate from "components/user-page-template/user-page-template";

export default function Judges() {
  return <UserPageTemplate userRoute="/judges" nameOfUser="Judge" />;
}
